module.exports = __webpack_public_path__ + "img/menu_1.c30cb367.png";